import React, { useEffect, useState } from "react";
import { Toast,ToastContainer } from "react-bootstrap";

function Footer(props) {
    
    const [showToast, setShowToast] = useState(props.showToast);
    const [toastMsg, setToastMsg] = useState('Operación completada con éxito');
    const [delay, setDelay] = useState(3000);

    useEffect(() => {
        setShowToast(props.showToast);
    },[props.showToast]);

    useEffect(() => {
        if (props.delay) {
            setDelay(props.delay);
        }
    },[props.delay]);

    useEffect(() => {
        if (props.message) {
            setToastMsg(props.message);
            setTimeout(() => { setShowToast(true) },800);
        }
    },[props.message]);

    useEffect(() => {
        if (localStorage.getItem('showtoast')) {
            setShowToast(localStorage.getItem('showtoast'));
            localStorage.removeItem('toastmsg');
            localStorage.removeItem('showtoast');
        }
        if (localStorage.getItem('toastmsg')) {
            setTimeout(() => { setShowToast(true) },800);
            setToastMsg(localStorage.getItem('toastmsg'));
            localStorage.removeItem('toastmsg');
            localStorage.removeItem('showtoast');
        }
        if (localStorage.getItem('toastdelay')) {
            setDelay(localStorage.getItem('toastdelay'));
            localStorage.removeItem('toastdelay');
        }
    },[]);

    return (
            <>
            <footer className="main-footer">
                <strong>Copyright <a href="#">AURORA SOLUTIONS S.A.S</a>.</strong> Todos los derechos reservados
            </footer>
            <ToastContainer className="toast-exito">
                <Toast onClose={() => setShowToast(false)} show={showToast} delay={delay} autohide>
                    <Toast.Body><i className="fas fa-check-circle"></i><p>{toastMsg}</p></Toast.Body>
                </Toast>
            </ToastContainer>
            </>
            );
}

export default Footer;